import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import cn from 'classnames';

import {
  Text,
  Heading,
  Icon,
  Button,
  Loading
} from 'components/common/Elements/Elements';

import { getRequest, postRequest } from 'utils/requests';
import { showNotif } from 'utils/notification';
import { setCurrentUser } from 'contexts/actions/authActions';
import { useAuthState, useAuthDispatch } from 'contexts/auth-context';

import classes from './ChangeRole.module.scss';
import { jarvisRoleNames } from 'data/constants';

const roleIconMap = {
  Jarvis_Developer: 'settings',
  CS_Admin: 'cs',
  CS_User: 'cs',
  SRE_User: 'cs',
  User: 'opportunity',
  Read_Only: 'opportunity'
};

const ChangeRole = ({ closeModal, info, setLoaderTable }) => {
  const [loader, setLoader] = useState(true);
  const [roleList, setRoleList] = useState([]);
  const [selectRole, setSelectRole] = useState({ index: 'none', nameRole: '' });

  const { auth } = useAuthState();
  const dispatch = useAuthDispatch();

  const { t } = useTranslation('settings');

  useEffect(() => {
    let cancelled = false;
    getRequest(`/settings/roles`)
      .then(res => {
        if (!cancelled) {
          setRoleList(res.body);
          setLoader(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          setLoader(false);
          console.log(err);
        }
      });
    return () => (cancelled = true);
  }, []);

  const handleRole = (item, index) => {
    setSelectRole({
      index,
      nameRole: item.name
    });
  };
  const postRole = () => {
    const url = `/settings/user/changerole`;
    const REQ_BODY = {
      userId: info.id,
      newRole: selectRole.nameRole
    };
    const toUpdate =
      info.id === auth.user.id && selectRole.nameRole !== auth.user.role;

    postRequest(url, REQ_BODY)
      .then(() => {
        showNotif({
          message: `The new role of ${info.changeName} - ${
            jarvisRoleNames[selectRole.nameRole]
          }`,
          kind: 'success',
          dismissAfter: 10000,
          type: 'alert'
        });
        setLoaderTable(true);
        if (toUpdate) {
          const update = Object.assign(auth.user, {
            role: selectRole.nameRole
          });
          dispatch(setCurrentUser(update));
        }
        closeModal(true);
      })
      .catch(err => {
        console.log(err);
        showNotif({
          message: `The new role of ${info.changeName} wasn't change`,
          kind: 'error',
          dismissAfter: 10000,
          type: 'alert'
        });
        closeModal();
      });
  };

  if (loader) {
    return <Loading />;
  }

  return (
    <>
      <Heading size={3} className={classes.titleList}>
        {t('settings:changeRoles.TITLE_HEADING_CHANGE_ROLES')}
      </Heading>
      <ul className={classes.listContainer}>
        {roleList.map((item, index) => (
          <li
            className={cn(
              index === Number(selectRole.index)
                ? classes.roleSelectLi
                : classes.roleLi
            )}
            key={item._id}
          >
            <Button
              onClick={() => handleRole(item, index)}
              id={index}
              data-name={item.displayName}
              className={cn(
                info.currentRole === item.name && classes.role_btn_disabled,
                classes.role_btn
              )}
              disabled={info.currentRole === item.name}
            >
              <div className={classes.roleSvgWrap}>
                <Icon
                  icon={roleIconMap[item.name] || 'allContacts'}
                  size="16px"
                  color="#3a5ba2"
                />
              </div>
              <div>
                <Heading size={3} className={classes.role_btn__header}>
                  {jarvisRoleNames[item.name] || ''}
                </Heading>
                <Text type="p" className={classes.role_description}>
                  {item.description}
                </Text>
              </div>
            </Button>
          </li>
        ))}
      </ul>
      <div className={classes.wrapperButton}>
        <Button className={classes.cancelButton} onClick={closeModal}>
          {t('settings:changeRoles.CANCEL_BUTTON')}
        </Button>
        <Button
          className={classes.buttonRoles}
          disabled={selectRole.index === 'none'}
          onClick={postRole}
        >
          {t('settings:changeRoles.APPLY_BUTTON')}
        </Button>
      </div>
    </>
  );
};

ChangeRole.propTypes = {
  closeModal: PropTypes.func.isRequired,
  info: PropTypes.shape({
    id: PropTypes.string.isRequired,
    changeName: PropTypes.string.isRequired,
    currentRole: PropTypes.string.isRequired
  }).isRequired,
  setLoaderTable: PropTypes.func.isRequired
};

export default ChangeRole;
